// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__10icf","approved":"Status_approved__eP74M","rejected":"Status_rejected__xiLT7","expired":"Status_expired__1ucSy","label":"Status_label__1fmtm"};